import React, {PureComponent} from "react";
import {formatToDay} from "../../../../../../utils";

/**
 * Input文本输入框
 */
class RmtDefault extends PureComponent {
    constructor(props) {
        super(props);
        this.state = {};
    }

    componentDidMount() {
    }

    componentWillUnmount() {
        this.setState({}, () => {
            return;
        })
    }

    getFinalValue = () => {
        let {fieldType, fieldFillRules = [], value} = this.props;
        const matchArrayAndObject = (obj = {}, array) => {
            if (array && Array.isArray(array)) {
                const commonKeys = array.filter(key => obj.hasOwnProperty(key));
                return commonKeys.map(key => obj[key]).join('，');
            }
            if (obj && typeof obj === "object") {
                return obj[value];
            }
            return "";
        }
        switch (fieldType) {
            case 3:
                return fieldFillRules && fieldFillRules.map(item => item?.keyValueMaps[value]);
            case 4:
                return fieldFillRules.map(item => matchArrayAndObject(item?.keyValueMaps, value))
            case 5:
                return value ? formatToDay(value) : "";
            default:
                return value;
        }
    }

    render() {
        let finaleValue = this.getFinalValue();
        return (
            <div className={"position-manage-detail-value"} style={{whiteSpace: "pre-wrap", wordBreak: "break-all"}}>
                {finaleValue}
            </div>
        )
    }
}

export default RmtDefault;